var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('site-header'),_c('product-detail',{attrs:{"product":_vm.product}}),_c('order-steps'),_c('content-blocks',{ref:"contentBlocks"}),_c('product-slider',{ref:"productSlider"}),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }